var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.89,
    height: 10.701,
    viewBox: "0 0 11.89 10.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-filter",
    "data-name": "Icon feather-filter",
    transform: "translate(-1.25 -1.875)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.14,1.875H1.25L6.006,7.5v3.888l2.378,1.189V7.5Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.405330657958984 2.874995231628418 L 6.769434452056885 6.852994918823242 C 6.922094345092773 7.033524990081787 7.005864143371582 7.262295246124268 7.005864143371582 7.498724937438965 L 7.005864143371582 10.76854515075684 L 7.383784294128418 10.9575023651123 L 7.383784294128418 7.498724937438965 C 7.383784294128418 7.262295246124268 7.467554092407227 7.033524990081787 7.620213985443115 6.852994918823242 L 10.98431777954102 2.874995231628418 L 3.405330657958984 2.874995231628418 M 1.250003814697266 1.874995231628418 L 13.13964462280273 1.874995231628418 L 8.383784294128418 7.498724937438965 L 8.383784294128418 12.57552528381348 L 6.005864143371582 11.3865852355957 L 6.005864143371582 7.498724937438965 L 1.250003814697266 1.874995231628418 Z",
    stroke: "none",
    fill: "#185cff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageFilter);
export default __webpack_public_path__ + "static/media/manage-filter.e45356aadf1ad304e4c169484922febf.svg";
export { ForwardRef as ReactComponent };